<template>
    <div class="brasilidade-intro content d-flex flex-align-center">
        <BrasilidadeMap class="flex-item-grow" @click="selectRegion" />
        <div class="flex-item-grow" style="max-width: 60ch">
            <h1 class="text-info flex-child-fixed mt-0">Brasilidade</h1>
            <p class="flex-child-fixed">
                Gigante pela própria natureza - esse é o Brasil que nós amamos. Cada cantinho do
                país transborda cultura, arte, pluralidade e diversidade. E é disso que a gente
                gosta: um país banhado por mares, rios e florestas e muita gente boa!
            </p>
            <p class="flex-child-fixed">
                A página Brasilidade nasceu com o objetivo de aproximar cada vez mais a Chico Rei do
                país em que vivemos. Te convidamos a fazer parte dessa aventura com a gente: venha
                descobrir nuances e peculiaridades que tornam o Brasil essa pátria amada e
                multicultural.
            </p>
            <p class="text-info text-bold text-size-4 text-yanone mt-4">
                Clique nas regiões do mapa e revisite este país imaginado com carinho por tanta
                gente que faz do Brasil, casa.
            </p>
        </div>
    </div>
</template>

<script>
    import BrasilidadeMap from './BrasilidadeMap';

    export default {
        name: 'BrasilidadeIntro',

        components: { BrasilidadeMap },

        methods: {
            selectRegion(name) {
                this.$router.push({ name: `${name.toLowerCase()}-home` });
            },
        },
    };
</script>
